const translations = {
    confirmDisconnect: 'Disconnect?',
    confirmDisconnectMessage: 'Are you sure you want to disconnect this service?',
    disconnect: 'Yes, disconnect'
};

export default translations;
